<template>
  <div class="uploader">
    <a-space :size="10">
      <a-upload
        v-if="fileList.length === 0"
        :fileList="fileList"
        :beforeUpload="() => false"
        @change="onFileChange"
      >
        <a-button type="primary">Выбрать файл</a-button>
      </a-upload>

      <a-button v-if="isCancelButtonVisible" @click="cancel">Отмена</a-button>

      <a-button
        v-if="isStartButtonVisible"
        type="primary"
        :loading="currentStatus === statuses.UPLOADING"
        @click="startUploading"
      >
        {{ currentStatus === statuses.UPLOADING ? 'Загрузка' : 'Начать загрузку' }}
      </a-button>

      <div v-if="currentStatus === statuses.SUCCESS" class="success">Файл загружен</div>
      <div v-if="currentStatus === statuses.ERROR" class="error">Ошибка</div>
    </a-space>
  </div>
</template>

<script>
import axios from 'axios';
import store from '@/store';
import {storage} from "@/helpers";

const statuses = Object.freeze({
  INIT: 'init',
  SELECTED: 'selected',
  LOADING_PARAMS: 'loadingParams',
  PARAMS_LOADED: 'paramsLoaded',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
});

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;

export default {
  name: 'DatasetUploader',

  data: () => ({
    statuses,
    currentStatus: statuses.INIT,
    fileList: [],
    params: {
      url: '',
      fields: {},
    },
  }),

  computed: {
    isReadyToUpload() {
      return this.currentStatus === statuses.PARAMS_LOADED;
    },
    isStartButtonVisible() {
      return this.isReadyToUpload || this.currentStatus === statuses.UPLOADING;
    },
    isCancelButtonVisible() {
      return (
        this.currentStatus !== statuses.UPLOADING &&
        this.currentStatus !== statuses.SUCCESS &&
        this.fileList.length > 0
      );
    },
    file() {
      return this.fileList[0] ?? null;
    },
  },

  methods: {
    cancel() {
      this.fileList = [];
      this.currentStatus = statuses.INIT;
    },

    onFileChange(info) {
      if (info.fileList.length === 0) {
        this.currentStatus = statuses.INIT;

        return;
      }

      let fileList = [...info.fileList];

      fileList = fileList.slice(-1);

      this.fileList = fileList;
      this.currentStatus = statuses.SELECTED;
      this.loadParams(this.file);
    },

    loadParams(file) {
      this.currentStatus = statuses.LOADING_PARAMS;

      this.axios
        .post(`${apiUrl}/upload/primary_data`, {
          filename: file.name,
          filesize: file.size / 10 ** 6,
        }, {
          // headers: {
          //   'finch-auth': `Bearer ${storage.get('authToken')}`
          // }
        })
        .then(({ data }) => {
          if (data.error === 0) {
            this.params = data;
            this.currentStatus = statuses.PARAMS_LOADED;
          } else {
            const msg = data.error === 1 ? 'Ошибка. Файл слишком мал.' : 'Ошибка в названии файла.';
            this.$notification.error({
              message: msg,
            });
            this.cancel();
          }
        })
        .catch((error) => {
          this.error = error.data;
          this.currentStatus = statuses.ERROR;
        });
    },

    startUploading() {
      if (!this.isReadyToUpload) {
        return;
      }

      this.currentStatus = statuses.UPLOADING;

      const formData = new FormData();

      // eslint-disable-next-line no-restricted-syntax,no-unused-vars
      for (const [key, value] of Object.entries(this.params.fields)) {
        formData.append(key, value.toString());
      }

      formData.append('file', this.file.originFileObj, this.file.name);

      axios
        .post('/s3/rosstat-storage', formData)
        .then(() => {
          this.sendHistory();
        })
        .catch(() => {
          this.currentStatus = statuses.ERROR;
        });
    },

    sendHistory() {
      let splitted_name = this.file.name.split('_')
      splitted_name = splitted_name[splitted_name.length-1].split('.')[0]
      // axios
      //   .post(`${apiUrl}/upload/primary_history`, {
      //     filename: this.file.name,
      //     username: store.state.user.username,
      //     filesize: this.file.size / 10 ** 6,
      //   }, {
      //     headers: {
      //       'finch-auth': `Bearer ${storage.get('authToken')}`
      //     }
      //   })
      //   .then(() => {
      //     this.fileList = [];
      //     this.currentStatus = statuses.SUCCESS;
      //   })
      //   .catch(() => {
      //     this.currentStatus = statuses.ERROR;
      //   });
       this.axios
        .post(`${apiUrl}/worker/start_job`, {
          pipeline: 'rosstat_fns_ftp_pipeline',
          run_config: {
            solids: {
              solid_fns_download: {
                config: {
                  period: splitted_name,
                  source: 'external_media'
                },
              },
            },
          },
          mode: 'default',
        }, {
          headers: {
            'finch-auth': `Bearer ${storage.get('authToken')}`,
            'fio': encodeURIComponent(store.state.userFio),
            'region': encodeURIComponent(store.state.regionName)
          }
        })
        .then(() => {
          this.fileList = [];
          this.currentStatus = statuses.SUCCESS;
          this.$notification.success({
            message: 'Загрузка началась. Смотрите журнал приема данных',
          });
        })
        .catch((err) => {
          console.log(err);
          this.currentStatus = statuses.ERROR;
          this.$notification.error({
            message: 'Произошла ошибка. Обратитесь к администратору',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.uploader {
}
</style>
